import React, {  useState } from "react";
import {  Grid } from "@mui/material";
import styles from "./styles/styles.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import {  postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import { useLocation, useNavigate } from "react-router-dom";
import FormikInput from "../../commonComponents/InputField/FormikInput";
import MainLoader from "../../commonComponents/loader/MainLoader";

function FourthStep({setStep}) {
  let { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (val) => {
    setLoading(true);
    const {
      device_name,
    } = val;
    let url = state?._id
      ? apiEndPoint().UPDATE_DEVICE
      : apiEndPoint().CREATE_DEVICE2;
    const { status, data } = await postApi({
      url,
      params: {
        id: state?._id,
        device_name,
        code: localStorage.getItem("code")
      },
    });
    tostMessage(status, data?.message);
    if (status === 200) {
      navigate("/signin");
      setStep(0)
    }
    setLoading(false);
    console.log(status, data);
  };
  const initialVal = {
    device_name: state ? state?.device_name : "",
  };
  const validationSchema = Yup.object().shape({
    device_name: Yup.string()
      .required("Device name is required"),
    
      
  });
  if (loading) {
    return <MainLoader />;
  }
  return (
    <div style={{paddingTop:"2rem"}}>
      <Formik
        initialValues={initialVal}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              rowSpacing={0.5}
            >
              <Grid item xs={12} >
                <FormikInput
                  placeholder="Device name"
                  labelVal="Device Name"
                  name="device_name"
                  touched={touched.device_name}
                  errors={errors.device_name}
                />
              </Grid>
              
 
            </Grid>
            <div
              className={styles.addRole}
              style={{ marginBlock: "1rem", justifyContent: "end" }}
            >
              <button type="submit" className={styles.buttonAddRole}>
                {state ? "Update Device" : <>Submit</>}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default FourthStep